import * as firebase from 'firebase';
import _ from 'lodash';
import axios from 'axios';
import querystring from 'qs';

import { SHIP_ORDER_PATH } from './ServicePath';

export const FETCH_ORDERS = 'fetch_orders';
export const FETCH_ORDERS_SUCCESS = 'fetch_orders_success';
export const FETCH_ORDERS_FAIL = 'fetch_orders_fail';

export const SHIP_ORDER = 'ship_order';
export const SHIP_ORDER_SUCCESS = 'ship_order_success';

export const FETCH_ORDER = 'fetch_order';
export const FETCH_ORDER_SUCCESS = 'fetch_order_success';
// export const FETCH_ORDER_FAIL = 'fetch_order_fail';

export function fetchAllOrders() {
  // TODO: fetch in batch
  const ordersRef = firebase.database().ref('orders');

  return (dispatch) => {
    dispatch({ type: FETCH_ORDERS });

    ordersRef.on('value', (snapshot) => {

      if (snapshot) {
        let rawOrders = [];
        snapshot.forEach(userOrderSnapshot => {

          const orderValue = userOrderSnapshot.val();

          if (orderValue) {
            const uid = userOrderSnapshot.key;
            // earch order from this user
            _.map(orderValue, (order, orderId) => {
              if (typeof order.PaymentResponse !== 'undefined' && typeof order.status !== 'undefined') {

                rawOrders.push({ ...order, orderId: orderId, uid: uid });
              }
            });
          }
        });

        console.log(rawOrders);

        dispatch({
          type: FETCH_ORDERS_SUCCESS,
          payload: rawOrders
        });
      } else {
        console.log('No orders in db!');
      }
    });
  };
}

// orderUser node
export function fetchSingleOrder(uid, orderId, callback) {

  return (dispatch) => {

    dispatch({
      type: FETCH_ORDER
    });

    fetchOrder(uid, orderId, (orderObject) => {

      dispatch({
        type: FETCH_ORDER_SUCCESS,
        payload: orderObject
      });

    });
  };
}

function fetchOrder(uid, orderId, callback) {

  const orderRef = firebase.database().ref('orders').child(uid).child(orderId);

  orderRef.once('value', snapshot => {
    const order = snapshot.val();

    const { address_id } = order;

    // fetch address
    fetchAddress(uid, address_id, address => {

      if (address) {
        const orderObject = {
          ...order,
          orderId: orderId,
          uid: uid,
          address: { ...address, addressId: address_id }
        }


        if (callback) {
          callback({ [orderId]: orderObject });
        }
      }
    });
  })
    .catch(error => {
      console.log(error.message);

      if (callback) {
        callback(null, error.message);
      }
    });
}

function fetchAddress(uid, addressId, callback) {

  const addressRef = firebase.database().ref('addresses').child(uid).child(addressId);

  addressRef.once('value', snapshot => {
    const address = snapshot.val();

    if (callback) {
      callback(address)
    }
  })
    .catch(error => {
      console.log(error.message);

      if (callback) {
        callback(null, error.message);
      }
    });
}

// NEW 2018
// from -> latest date of orders

export function fetchOrders(from, limit) {

  // search from 'orderUser'
  const ordersRef = firebase.database().ref('orderUser');

  return (dispatch) => {

    dispatch({
      type: FETCH_ORDERS
    });

    ordersRef.orderByChild('createdDate').limitToLast(limit).on('value', snapshot => {

      let rawOrders = {}
      const orderCount = snapshot.numChildren();
      let orderIndex = 0;

      // no results
      if (orderCount === 0) {
        dispatch({
          type: FETCH_ORDERS_SUCCESS,
          payload: rawOrders
        });
      }

      console.log('Update Orders!');

      // has results
      snapshot.forEach(userOrderSnapshot => {

        const { uid, addressId } = userOrderSnapshot.val();
        // 1. Fetch each orders 1-by-1
        // fetchOrder();
        let orderId = userOrderSnapshot.key;

        fetchOrder(uid, orderId, order => {
          // this 'order' includes 'address'
          orderIndex += 1;

          if (order) {
            // assign
            _.merge(rawOrders, order);

            // check if last one
            if (orderIndex === orderCount) {
              // done
              finalizeOrderFetch(dispatch, rawOrders);
            }
            // // fetch address
            // fetchAddress(uid, addressId, address => {


            //     if (address) {
            //         rawOrders.push({
            //             ...order,
            //             orderId: orderId,
            //             uid: uid,
            //             address: { ...address, addressId: addressId }
            //         });
            //     }


            // });
          }
        });
      });
    }, (cancel, context) => {
      console.log(cancel);
    });
  };
}

function finalizeOrderFetch(dispatch, orders) {
  console.log('Finalize order fetch');

  dispatch({
    type: FETCH_ORDERS_SUCCESS,
    payload: orders
  });
}

export function shipOrder(uid, orderId, trackingNumber, callback) {

  return (dispatch) => {

    dispatch({
      type: SHIP_ORDER
    });

    axios.post(SHIP_ORDER_PATH, querystring.stringify({
      uid: uid,
      orderId: orderId,
      trackingNumber: trackingNumber
    }))
      .then(response => {
        console.log(response);

        dispatch({
          type: SHIP_ORDER_SUCCESS
        });

        callback(true);
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: SHIP_ORDER_SUCCESS
        });

        callback(false);
      });
  };
}


// WEBPACK FOOTER //
// ./src/actions/Order.js